import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Layout from './Layout';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  loader: {
    position: 'fixed',
    left: '50%',
    top: '40%',
    zIndex: 100
  },
  loaderContainer: {
    position: 'fixed',
    top: 0,
    zIndex: 2000,
    background: 'white',
    opacity: '.97',
    width: '100%',
    height: '100%'
  },
  hidden: {
    display: 'none'
  }
}));

const App = () => {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);

  // Initial setup
  const setupPage = (content: HTMLElement) => {
    const mainContent = document.getElementById('main-content');
    if (mainContent && content) {
      mainContent.prepend(content);
    }
    const languagesDropdown = document.getElementById('languages-dropdown') as HTMLElement;
    const profileContainer = document.getElementById('profile-container');
    if (profileContainer && languagesDropdown) {
      profileContainer.prepend(languagesDropdown);
    }
    languagesDropdown.style.display = 'flex';
    content.style.display = 'block';

    const navContainer = document.getElementById('PFnavContainer') as HTMLElement;
    if (navContainer) {
      navContainer.style.zIndex = 'auto';
    }
    setLoading(false);
  };

  // Call setupPage on initial load
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const content: HTMLElement | null = document.getElementById('liquid_form') ||
        document.getElementById('content-container') ||
        document.getElementById('content_form') ||
        document.querySelector('.container');
      if (content) {
        setupPage(content);
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <Router>
      <div className={clsx(classes.loaderContainer, {
        [classes.hidden]: !loading
      })}>
        <CircularProgress size={100} className={classes.loader} />
      </div>
      <Switch>
        <Route path="/:lang" render={(props) => <Layout setLoading={setLoading} />} />
      </Switch>
    </Router>
  );
}

export default App;
